import { ThemeProvider } from "@mui/material";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./app/App.js";
import store from "./app/store";
import { theme } from "./app/theme";
import { validateEnvironment } from "./common/utils/envValidation";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

// Validate environment variables before app initialization
try {
  validateEnvironment();
} catch (error) {
  // Show error message in the DOM instead of just console
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <div
      style={{
        padding: "40px",
        fontFamily: "system-ui, -apple-system, sans-serif",
        maxWidth: "600px",
        margin: "0 auto",
        lineHeight: "1.6",
      }}
    >
      <h1 style={{ color: "#d32f2f", marginBottom: "20px" }}>
        ⚠️ Configuration Error
      </h1>
      <pre
        style={{
          background: "#f5f5f5",
          padding: "20px",
          borderRadius: "8px",
          whiteSpace: "pre-wrap",
          fontSize: "14px",
          border: "1px solid #ddd",
        }}
      >
        {error.message}
      </pre>
      <p style={{ marginTop: "20px", color: "#666" }}>
        This app requires environment variables to be configured. Please check
        the console for more details or contact your administrator.
      </p>
    </div>
  );

  // Also log to console for developers
  console.error("Environment validation failed:", error);
  throw error; // Stop execution
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </Provider>
);

reportWebVitals();
